import { Box, Stack } from "@mui/material"

import QLightLogo from "@assets/q_light_logo"
import HomeOutlined from "@assets/svg_icons/home_outlined"
import { useLeftNavigationContext } from "@contexts/left_navigation_context"
import ItemContainer from "@layouts/main_layout/sub_components/navigation_panel/sub_components/item_container"
import NavigationButton from "@layouts/main_layout/sub_components/navigation_panel/sub_components/navigation_button"
import DiscountIcon from "@mui/icons-material/Discount"
import LinkOffIcon from "@mui/icons-material/LinkOff"
import PeopleAltIcon from "@mui/icons-material/PeopleAlt"
import PersonIcon from "@mui/icons-material/Person"
import PhonelinkSetupIcon from "@mui/icons-material/PhonelinkSetup"
import TerminalIcon from "@mui/icons-material/Terminal"
import WidgetsIcon from "@mui/icons-material/Widgets"
import WhatsAppIcon from "@mui/icons-material/WhatsApp"

import AutomationOutlined from "@assets/svg_icons/automation_outlined"
import NavigationPanelProfile from "@layouts/main_layout/sub_components/navigation_panel/sub_components/profile"
import { Call } from "@mui/icons-material"
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined"
import MailIcon from "@mui/icons-material/Mail"
import StoreIcon from "@mui/icons-material/Store"
import { RoleTypes } from "__generated__/graphql"
import styles from "./styles"

export default function NavigationPanel() {
  const { me, translate } = useLeftNavigationContext()

  return (
    <Stack sx={styles.container}>
      <ItemContainer>
        <QLightLogo />
      </ItemContainer>
      <Box sx={{ pt: "1rem" }}>
        <NavigationButton
          target="/dashboard"
          tooltip={translate("dashboard_tooltip")}
        >
          <HomeOutlined />
        </NavigationButton>
        {me?.role === RoleTypes.Admin && (
          <NavigationButton
            target="/users"
            tooltip={translate("users_tooltip")}
          >
            <PersonIcon sx={{ color: "#fff" }} />
          </NavigationButton>
        )}
        {me?.role === RoleTypes.Admin && (
          <NavigationButton
            target="/scripts"
            tooltip={translate("scripts_tooltip")}
          >
            <TerminalIcon sx={{ color: "#fff" }} />
          </NavigationButton>
        )}
        {me?.role === RoleTypes.Admin && (
          <NavigationButton
            target="/mobile-app-version"
            tooltip={translate("mobile_app_version_tooltip")}
          >
            <PhonelinkSetupIcon sx={{ color: "#fff" }} />
          </NavigationButton>
        )}
        {me?.role === RoleTypes.Admin && (
          <NavigationButton
            target="/livechat-widget"
            tooltip={translate("live_chat_widget_tooltip")}
          >
            <WidgetsIcon sx={{ color: "#fff" }} />
          </NavigationButton>
        )}
        <NavigationButton
          target="/coupons"
          tooltip={translate("coupons_tooltip")}
        >
          <DiscountIcon sx={{ color: "#fff" }} />
        </NavigationButton>
        <NavigationButton
          target="/campaign-links"
          tooltip={translate("campaign_links_tooltip")}
        >
          <LinkOffIcon sx={{ color: "#fff" }} />
        </NavigationButton>
        <NavigationButton target="/whatsapp" tooltip={"Whatsapp"}>
          <WhatsAppIcon sx={{ color: "#fff" }} />
        </NavigationButton>
        <NavigationButton target="/customers" tooltip={translate("customers")}>
          <PeopleAltIcon sx={{ color: "#fff" }} />
        </NavigationButton>
        <NavigationButton target="/ai" tooltip="AI Hub">
          <AutomationOutlined />
        </NavigationButton>
        <NavigationButton target="/call-logs" tooltip={translate("call_logs")}>
          <Call sx={{ color: "#fff" }} />
        </NavigationButton>
        <NavigationButton
          target="/email-logs"
          tooltip={translate("email_logs")}
        >
          <MailIcon sx={{ color: "#fff" }} />
        </NavigationButton>
        <NavigationButton
          target="/marketplace-orders"
          tooltip={translate("marketplace_orders")}
        >
          <StoreIcon sx={{ color: "#fff" }} />
        </NavigationButton>
        {me?.role === RoleTypes.Admin && (
          <NavigationButton
            target="/changelog"
            tooltip={translate("changelog_tooltip")}
          >
            <CampaignOutlinedIcon sx={{ color: "#fff" }} />
          </NavigationButton>
        )}
      </Box>
      <Stack sx={styles.bottomArea}>
        <NavigationPanelProfile />
      </Stack>
    </Stack>
  )
}
